export default "__VITE_ASSET__$MUfDjGG__"